import { render } from "./applications.vue?vue&type=template&id=6813819a&scoped=true"
import script from "./applications.vue?vue&type=script&lang=js"
export * from "./applications.vue?vue&type=script&lang=js"

import "./applications.vue?vue&type=style&index=0&id=6813819a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6813819a"]])

export default __exports__